import { useTranslation } from 'react-i18next';

import type { PatientInquiryStatus } from '../types/patient-inquiry.types';

interface PatientInquiryStatusBadgeProps {
  status: PatientInquiryStatus;
}

// PRD §4.3 / §5: PENDING (대기, red) / ANSWERED (답변완료, green).
export function PatientInquiryStatusBadge({ status }: PatientInquiryStatusBadgeProps) {
  const { t } = useTranslation('admin');
  const className =
    status === 'ANSWERED' ? 'badge badge-success' : 'badge badge-destructive';
  return <span className={className}>{t(`patientInquiry.statuses.${status}`)}</span>;
}
